/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRangeCurrency_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRange_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuInputRangeCurrency_itemSearch";
};
export type SbSharedRefineMenuInputRangeCurrency_itemSearch$data = SbSharedRefineMenuInputRangeCurrency_itemSearch;
export type SbSharedRefineMenuInputRangeCurrency_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuInputRangeCurrency_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeCurrency_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRangeCurrency_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '5b5209934a174c24d6951bf82e480726';
export default node;
